// import extend from 'just-extend'
// import clone from 'just-clone'
import { createStore } from 'vuex'
import useApi from '@/hooks/useApi'
import router from '@/router'

const api = useApi()

// import STORE_STATE_DEFAULT_PROFILE from '@/constants/STORE_STATE/STORE_STATE_DEFAULT_PROFILE'

const proxyToAsyncMutation =
  mutationName =>
  async ({ commit }) => {
    return await commit(mutationName)
  }

// eslint-disable-next-line
const proxyToMutation =
  mutationName =>
  ({ commit }) => {
    return commit(mutationName)
  }

const store = createStore({
  state: {
    // profile: STORE_STATE_DEFAULT_GEBRUIKER,
    timing: {
      pageOpen: Date.now(),
      pageInit: 0,
      pageLoaded: 0,
    },
    app: {
      newContent: false,
    },
    profile: {
      id: -1,
    },
    COUNTERS: {
      INVOICES: {
        NO_PAYMENTS: 0,
        REMAINING: 0,
      },
      PRODUCTION: {
        BACKLOG: 0,
        DECOUPAGE: 0,
        POLISSAGE: 0,
      },
    },
  },
  getters: {
    ready(state) {
      return state.timing.pageLoaded > 0
    },
    isAuthenticated(state) {
      return state.profile?.id > 0
    },
    /*
    getSetting(state) {
      return (name, defaultValue = null) => {
        return state[name] || defaultValue
      }
    },
    */
  },
  mutations: {
    async GET_COUNTERS(state) {
      const { data } = await api.stats.counters()
      if (data.INVOICES && data.PRODUCTION) {
        Object.entries(data.INVOICES).forEach(([k, v]) => {
          state.COUNTERS.INVOICES[k] = v
        })
        Object.entries(data.PRODUCTION).forEach(([k, v]) => {
          state.COUNTERS.PRODUCTION[k] = v
        })
      }
    },
    async GET_PROFILE(state, cb) {
      const { data } = await api.auth.profile()
      state.profile = data?.profile || null
      if (typeof cb === 'function') cb(state.profile)
      return state.profile
    },
    async ON_CLIENT_INIT(state) {
      if (state.timing.pageInit > 0) {
        return false
      }
      state.timing.pageInit = Date.now()
      await new Promise(r => store.commit('GET_PROFILE', r))
      const newRoute = store.getters.isAuthenticated ? '/dashboard' : '/login'
      const pathname = location?.pathname || '/'
      if (['/dashboard', '/login'].includes(pathname) && pathname !== newRoute) {
        router.push(newRoute).finally(() => {
          state.timing.pageLoaded = Date.now()
        })
      } else {
        state.timing.pageLoaded = Date.now()
      }
      return true
    },
    SET_APP_NEW_CONTENT(state, value) {
      state.app.newContent = !!value
    },
  },
  actions: {
    GET_COUNTERS: proxyToAsyncMutation('GET_COUNTERS'),
    GET_PROFILE: proxyToAsyncMutation('GET_PROFILE'),
    ON_CLIENT_INIT: proxyToAsyncMutation('ON_CLIENT_INIT'),
    SET_APP_NEW_CONTENT: proxyToMutation('SET_APP_NEW_CONTENT'),
  },
  modules: {},
})

export default store
